<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="中文标题超长自动截断:" >
                                <el-checkbox v-model="value.chineseTitleAutoTruncate" :true-label="1" :false-label="0">商品标题超过平台限制自动截断（最多500个字符）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="英文标题超长自动截断:" >
                                <el-checkbox v-model="value.englishTitleAutoTruncate" :true-label="1" :false-label="0">商品标题超过平台限制自动截断（最多500个字符）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="货号设置:" >
                                <el-checkbox v-model="value.autoFillProductNumber" :true-label="1" :false-label="0">基础资料款式编码自动填充到Temu货号</el-checkbox>
                                <div class="tips">（注意：开启配置，新增Temu资料时，基础资料款式编码自动填充Temu货号，若Temu资料已完善，则不会自动填充。）</div>
                            </el-form-item>
                            <el-form-item label="SKU货号设置:" >
                                <el-checkbox v-model="value.autoFillSkuNumber" :true-label="1" :false-label="0">基础资料款式编码自动填充到Temu SKU货号</el-checkbox>
                                <div class="tips">（注意：开启配置，新增Temu资料时，基础资料款式编码自动填充Temu资料 SKU 货号，若Temu资料已完善，则不会自动填充。）</div>
                            </el-form-item>
                            <el-form-item label="商品产地配置" >
                                <el-select
                                    v-model="value.productWhExtAttrVo.productOrigin.region1ShortName"
                                    filterable
                                    clearable
                                >
                                    <el-option v-for="op in countryCodes" :key="op.code" :value="op.code" :label="op.name"></el-option>
                                </el-select>
                                <el-select
                                    v-if="value.productWhExtAttrVo.productOrigin.region1ShortName === 'CN'"
                                    v-model="value.productWhExtAttrVo.productOrigin.region2Id"
                                    filterable
                                    clearable
                                    placeholder="请选择省份"
                                    style="margin-left: 10px"
                                >
                                    <el-option v-for="op in regionIdOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
                                </el-select>
                                <span style="color:#ccc;font-size:12px;">商家未在此预设时，商品编辑抽屉的产地字段为空，需手填</span>
                                <div class="flex" style="font-size:12px;color:#606266;" v-show="value.productWhExtAttrVo.productOrigin.region1ShortName && value.productWhExtAttrVo.productOrigin.region1ShortName !== 'CN'" >
                                    产地证明（选填）: 
                                    <el-upload
                                        class="product-origin-upload-btn"
                                        action="#"
                                        accept=".jpg,.jpeg,.png"
                                        :limit="1"
                                        :auto-upload="false"
                                        :file-list="productOriginFileList"
                                        :on-preview="productOriginPreview"
                                        :on-change="productOriginFileChange"
                                        :on-remove="productOriginFileRemove"
                                    >
                                        <el-link :underline="false" v-if="!productOriginImg">上传文件</el-link>
                                    </el-upload>
                                    <span class="ml-5">单张单张≤3MB，支持JPG/PNG</span>
                                </div>
                            </el-form-item>
                            <el-form-item label="是否定制商品" >
                                <el-radio-group v-model="value.customizedTechnologyVo.personalizationSwitch" size="mini">
                                    <el-radio :label="1" border>定制商品</el-radio>
                                    <el-radio :label="0" border>非定制商品</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <template v-if="value.customizedTechnologyVo.personalizationSwitch === 1">
                                <el-form-item label="工艺类型">
                                    <el-radio-group v-model="value.customizedTechnologyVo.technologyType" @change="technologyTypeChange">
                                        <el-radio v-for="op in technologyTypeOpts" :key="op.value" :label="op.value">{{ op.label }}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    label="工艺分类"
                                    prop="customizedTechnologyVo.firstType"
                                    v-if="technologyMap[value.customizedTechnologyVo.technologyType]"
                                >
                                    <el-select v-model="value.customizedTechnologyVo.firstType" @change="technologyFirstTypeChange">
                                        <el-option
                                        v-for="op in technologyMap[value.customizedTechnologyVo.technologyType]"
                                        :key="op.id"
                                        :value="op.id"
                                        :label="op.name"
                                        ></el-option>
                                    </el-select>
                                    <el-select
                                        v-show="value.customizedTechnologyVo.technologyType == 1"
                                        v-model="value.customizedTechnologyVo.twiceType"
                                        style="margin-left: 10px"
                                        :disabled="!twiceTypeOpts.length"
                                    >
                                        <el-option v-for="op in twiceTypeOpts" :key="op.id" :value="op.id" :label="op.name"></el-option>
                                    </el-select>
                                    <el-select
                                        v-show="value.customizedTechnologyVo.technologyType == 2"
                                        v-model="value.customizedTechnologyVo.multipleTwiceType"
                                        style="margin-left: 10px"
                                        collapse-tags
                                        multiple
                                        :multiple-limit="0"
                                        :disabled="!twiceTypeOpts.length"
                                    >
                                        <el-option v-for="op in twiceTypeOpts" :key="op.id" :value="op.id" :label="op.name"></el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>图片设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="商品轮播图:" >
                                <el-checkbox v-model="value.carouselAutoTruncate" :true-label="1" :false-label="0">商品轮播图超过平台限制自动截断（最多10张）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="图片修正规则:" >
                                <div>按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，需调整后重新上传。</div>
                                <el-checkbox-group v-model="value.autoCropImageConfigList">
                                    <el-checkbox label="CarouselImg">商品轮播图</el-checkbox>
                                    <el-checkbox label="SkcCarouselImg">服饰类商品轮播图</el-checkbox>
                                    <el-checkbox label="Desc">商品详情图</el-checkbox>
                                    <el-checkbox label="SkuImg">预览图</el-checkbox>
                                    <el-checkbox label="MaterialImg">商品素材图</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="规格图调整时规格预览图:" >
                                <el-radio-group v-model="value.skuImageChangePreview">
                                    <el-radio :label="1">变更</el-radio>
                                    <el-radio :label="0">不变更<span style="font-size:10px;color:#ccc;">不变更时，TEMU规格图调整不影响预览图</span></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <PriceConf 
                        ref="priceConfRef" 
                        platform="pddtemu" 
                        :kj_commonPrice="{retailPriceConf:value.retailPriceConf,supplierPriceConf:value.supplierPriceConf}" 
                    />
                    <!-- <section>
                        <div class="title">
                            <span>素材语言默认勾选</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="" >
                                <el-checkbox-group v-model="checkList">
                                    <el-checkbox v-for="s in sourceLanguageList" :label="s.value" :disabled="s.value === 'en'" :key="s.value">{{s.label}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </section> -->
                    <section>
                        <div class="title">
                            <span>包装信息</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="外包装图片：" prop="productOuterPackageImages">
                                <div class="imgs-wrp">
                                    <div class="ft-12">
                                        铺货时只取主图，拖动可调整顺序
                                        <BatchEditImages
                                        v-model="value.productOuterPackageInfoVo.productOuterPackageImages"
                                        refName="productOuterPackageImagesRef"
                                        :getWidthAndHeights="getWidthAndHeights"
                                        ></BatchEditImages>
                                    </div>
                                    <MutiImgUpload
                                        ref="productOuterPackageImagesRef"
                                        v-model="value.productOuterPackageInfoVo.productOuterPackageImages"
                                        :size="150"
                                        :limitNums="6"
                                        :mainImgNums="0"
                                        :placeholderNum="3"
                                        :imgNames="['正拍图', '侧拍图', '俯拍图']"
                                    />
                                </div>
                            </el-form-item>
                            <el-form-item style="margin-top: 25px">
                                <div class="tips">
                                <div>1. 外包装图片要求1-6张，需包含正拍、侧拍和俯拍图片</div>
                                <div>2. 请确保图片中包含商品分类信息（如：包装上的商品名称、商品说明信息）</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="外包装类型：" prop="packageType">
                                <el-radio-group v-model="value.productOuterPackageInfoVo.productOuterPackage.packageType" size="mini">
                                <el-radio v-for="op in packageTypeOpts" :key="op.value" :label="op.value" border>{{ op.label }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item style="margin-top: 20px">
                                <div class="tips">
                                <div>硬包装：外包装为原色瓦楞纸箱，或者彩色纸箱已塑封：如笔记本电脑，电饭煲，带鞋盒的鞋子等</div>
                                <div>软包装+硬物：商品外包装形状会随着挤压会改变形状，但商品不会；如笔记本、手串装饰等</div>
                                <div>软包装+软物：商品外包装及商品形状会随着挤压会改变形状；如衣服，毛绒玩具等</div>
                                </div>
                            </el-form-item>
                            <el-form-item label="外包装形状：" prop="packageShape">
                                <el-radio-group v-model="value.productOuterPackageInfoVo.productOuterPackage.packageShape" size="mini">
                                <el-radio v-for="op in packageShapeOpts" :key="op.value" :label="op.value" border>{{ op.label }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>敏感属性与体积配置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="" prop="skuWhExtAttrVo" label-width="0" >
                                <ShopSensitiveAttr :shopList="shopList" v-model="value.skuWhExtAttrVo" />
                            </el-form-item>
                            <el-form-item label="" prop="categorySkuWhExtAttrList" label-width="0" >
                                <CategorySensitiveAttr :shopList="shopList" v-model="value.categorySkuWhExtAttrList" />
                            </el-form-item>
                        </div>
                    </section>
                    <div class="btns">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import { cloneDeep, isEmpty, merge, isEqual } from 'lodash';
import {saveCrossborderConfig,getCrossborderConfig} from '@servers/prod/conf/index.js'
import PriceConf from './components/PriceConfKj.vue';
import constantConfigs,{getDefaultProductWhExtAttr,getDefaultProductOuterPackageInfo} from '../center/components/TemuInfoForm/config.js'
import OSSClient from '@/components/Uploads/OSS-client';
import SizeChartTemp from '../center/components/TemuInfoForm/components/sizeChartTemp.vue';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import TemplateBlock from '../center/components/TemuInfoForm/components/TemplateBlock.vue';
import ShopSensitiveAttr from './components/temu/ShopSensitiveAttr.vue'
import CategorySensitiveAttr from './components/temu/CategorySensitiveAttr.vue'

const PLATFORMID = 'pddtemu';

const defalutSkuWhExtAttrVo = () => {
    return {
        productSkuSensitiveAttrReq:{
            isSensitive:0,
            sensitiveTypes:[],
        },
        productSkuSensitiveLimitReq:{
            maxBatteryCapacity: '',
            maxLiquidCapacity: '',
            maxKnifeLength: '',
            knifeTipAngle: { degrees: '' }
        },
        productSkuVolumeReq:{
            volumeHeight:'',
            volumeLen:'',
            volumeWidth:''
        },
        productSkuWeightReq:{
            weightValue: '', // 重量值，单位g
        },
    }
}
export default {
    props: {
        back: Function
    },
    components: {
        PriceConf,
        SizeChartTemp,
        BatchEditImages,
        MutiImgUpload,
        TemplateBlock,
        ShopSensitiveAttr,
        CategorySensitiveAttr,
    },
    data() {
        const validateSkuWhExtAttrVo = (rule, value, callback) => {
            if (value && value.productSkuVolumeReq) {
                const {volumeLen,volumeWidth,volumeHeight} = value.productSkuVolumeReq
                if(volumeLen < volumeWidth || volumeLen < volumeHeight || volumeWidth < volumeHeight){
                    this.$message.error('体积内容必须遵循 最长边 ≥ 次长边 ≥ 最短边原则')
                    return callback(new Error('体积内容必须遵循 最长边 ≥ 次长边 ≥ 最短边原则'));
                }
            }
            return callback();
        }
        const validateCategorySkuWhExtAttrList = (rule, value, callback) => {
            if (value) {
                let valid = true;
                (value || []).forEach(i => {
                    if(i.skuWhExtAttr && i.skuWhExtAttr.productSkuVolumeReq){
                        const {volumeLen,volumeWidth,volumeHeight} = i.skuWhExtAttr.productSkuVolumeReq
                        if(volumeLen < volumeWidth || volumeLen < volumeHeight || volumeWidth < volumeHeight){
                            valid = false
                        }
                    }
                });
                if(!valid){
                    this.$message.error('体积内容必须遵循 最长边 ≥ 次长边 ≥ 最短边原则')
                    return callback(new Error('体积内容必须遵循 最长边 ≥ 次长边 ≥ 最短边原则'));
                }
                return callback();
            } else {
                return callback();
            }
        }
        return {
            ...constantConfigs,
            value: {
                chineseTitleAutoTruncate: 0,
                englishTitleAutoTruncate: 0,
                autoFillProductNumber: 0,
                autoFillSkuNumber:0,
                productWhExtAttrVo:getDefaultProductWhExtAttr(),
                customizedTechnologyVo:{
                    personalizationSwitch:0,
                    technologyType:'',
                    firstType:'',
                    twiceType:'', // 工艺分类第二个下拉框组件--单选
                    multipleTwiceType:[],// 工艺分类第二个下拉框组件--多选(仅前端使用，字段不需要传给后端)
                },
                retailPriceConf:{}, // 价格设置:建议零售价通用配置
                supplierPriceConf:{}, // 价格设置:申报价通用配置 
                autoCropImageConfigList:[], // 图片设置:图片修正规则列表 
                productOuterPackageInfoVo:getDefaultProductOuterPackageInfo(), // 包装信息:外包装配置
                skuWhExtAttrVo:defalutSkuWhExtAttrVo(), // 敏感属性与体积:通用配置
                categorySkuWhExtAttrList:[], // 敏感属性与体积:类目维度配置列表
                skuImageChangePreview:1,
                carouselAutoTruncate:0,
            },
            rules: {
                skuWhExtAttrVo: [
                    {validator: validateSkuWhExtAttrVo}
                ],
                categorySkuWhExtAttrList: [
                    {validator: validateCategorySkuWhExtAttrList}
                ],
            },
            productOriginImg:'',
            productOriginFileList:[], // 产地证明
        }
    },
    computed:{
        twiceTypeOpts() {
            let twiceTypeOpts = [];
            const technologyType = this.value.customizedTechnologyVo.technologyType;
            const firstType = this.value.customizedTechnologyVo.firstType;
            if (technologyType && firstType) {
                const findItem = this.technologyMap[technologyType].find(item => item.id === firstType);
                twiceTypeOpts = findItem?.childDetail?.length ? findItem?.childDetail : [];
            }
            return twiceTypeOpts;
        },
        shopList(){
            let list = this.$store.getters.get_AllShops_BySource('pddtemu')
            return list
        },
    },
    mounted() {
        this.getConf();
    },
    methods: {
        async getConf() {
            const res = await getCrossborderConfig({platform: PLATFORMID});
            if (res) {
                let { 
                    productOuterPackageInfoVo,
                    skuWhExtAttrVo,
                    productWhExtAttrVo,
                    customizedTechnologyVo,
                    categorySkuWhExtAttrList,
                    skuImageChangePreview,
                    ...reset 
                } = res
                // 包装信息
                if(productOuterPackageInfoVo){ 
                    productOuterPackageInfoVo.productOuterPackageImages = (productOuterPackageInfoVo.productOuterPackageImages || []).map(imaItem => imaItem.imageUrl).filter(Boolean);
                }else{
                    productOuterPackageInfoVo = this.value.productOuterPackageInfoVo
                }
                //敏感属性与体积:通用配置
                if(!skuWhExtAttrVo){
                    skuWhExtAttrVo =  this.value.skuWhExtAttrVo
                }
                // 商品产地数据
                let defaultProductWhExtAttr = this.value.productWhExtAttrVo
                if(productWhExtAttrVo){
                    if(productWhExtAttrVo.productOrigin){
                        if(productWhExtAttrVo.productOriginCertFiles && productWhExtAttrVo.productOriginCertFiles.length){
                            this.productOriginFileList = productWhExtAttrVo.productOriginCertFiles.filter(i => i.fileUrl).map(i => ({
                                name: i.fileName,
                                url: i.fileUrl
                            }));
                            this.productOriginImg = this.productOriginFileList[0] ? this.productOriginFileList[0].url : ''
                        }else{
                            productWhExtAttrVo.productOriginCertFiles = defaultProductWhExtAttr.productOriginCertFiles
                        }
                    }else{
                        productWhExtAttrVo = defaultProductWhExtAttr; // 存在空数据初始化默认字段
                    }
                }else{
                    productWhExtAttrVo = defaultProductWhExtAttr
                }
                // 定制工艺配置
                if(customizedTechnologyVo){
                    if(customizedTechnologyVo.technologyType){ // 后端返回的是数字，前端用的是字符串，统一转成字符串，方便回显处理
                        customizedTechnologyVo.technologyType = customizedTechnologyVo.technologyType + ''
                    }
                    if(customizedTechnologyVo.technologyType == 2){
                        customizedTechnologyVo.multipleTwiceType = customizedTechnologyVo.twiceType || []
                        customizedTechnologyVo.twiceType = ''
                    }else{
                        customizedTechnologyVo.twiceType = customizedTechnologyVo.twiceType ? (customizedTechnologyVo.twiceType[0] || '') : ''
                    }
                }else{
                    customizedTechnologyVo = this.value.customizedTechnologyVo
                }
                // 敏感属性与体积:类目维度配置列表
                if(categorySkuWhExtAttrList && categorySkuWhExtAttrList.length){
                    categorySkuWhExtAttrList = categorySkuWhExtAttrList.map(i => ({
                        ...i,
                        categoryIds:i.categoryIds ? i.categoryIds.split(',') : []
                    }))
                }else{
                    categorySkuWhExtAttrList = this.value.categorySkuWhExtAttrList
                }
                this.value = {
                    productOuterPackageInfoVo,
                    skuWhExtAttrVo,
                    productWhExtAttrVo,
                    customizedTechnologyVo,
                    categorySkuWhExtAttrList,
                    skuImageChangePreview:skuImageChangePreview || 0,
                    ...reset,
                }
            }
        },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        customizedTechnologyVo,
                        categorySkuWhExtAttrList,
                        productOuterPackageInfoVo,
                        skuWhExtAttrVo,
                        productWhExtAttrVo,
                        ...reset
                    } = this.value;
                    let priceConf = this.$refs.priceConfRef.getData();
                    if(!priceConf){
                        this.$message.error('请填写价格配置中的汇率！')
                        return
                    }
                    // 商品产地
                    let newProductWhExtAttrVo = { ...productWhExtAttrVo };
                    let pFileList = (newProductWhExtAttrVo?.productOriginCertFiles || []).filter(i => i.fileUrl)
                    if(pFileList.length === 0){ // 不存在证明文件 productOriginCertFiles 置为null
                        newProductWhExtAttrVo.productOriginCertFiles = null
                    }
                    // 定制工艺配置
                    let _customizedTechnologyVo = {
                        ...customizedTechnologyVo,
                        twiceType: customizedTechnologyVo.technologyType == 1 ? [customizedTechnologyVo.twiceType] : customizedTechnologyVo.multipleTwiceType,
                    }
                    delete _customizedTechnologyVo.multipleTwiceType; // 删除前端使用的字段
                    //敏感属性与体积:通用配置
                    let newSkuWhExtAttrVo = {...skuWhExtAttrVo}
                    if(newSkuWhExtAttrVo.productSkuSensitiveAttrReq){
                        if(newSkuWhExtAttrVo.productSkuSensitiveAttrReq.isSensitive === 0 && newSkuWhExtAttrVo.productSkuSensitiveAttrReq.sensitiveTypes.length === 0){
                            newSkuWhExtAttrVo.productSkuSensitiveAttrReq = null
                        }
                    }
                    if(newSkuWhExtAttrVo.productSkuSensitiveLimitReq){
                        if(
                            !newSkuWhExtAttrVo.productSkuSensitiveAttrReq ||
                            (!newSkuWhExtAttrVo.productSkuSensitiveLimitReq.maxBatteryCapacity && 
                            !newSkuWhExtAttrVo.productSkuSensitiveLimitReq.maxKnifeLength && 
                            !newSkuWhExtAttrVo.productSkuSensitiveLimitReq.maxLiquidCapacity && 
                            !newSkuWhExtAttrVo.productSkuSensitiveLimitReq?.knifeTipAngle?.degrees)
                        ){
                            newSkuWhExtAttrVo.productSkuSensitiveLimitReq = null
                        }
                    }
                    if(newSkuWhExtAttrVo.productSkuVolumeReq){
                        if(!newSkuWhExtAttrVo.productSkuVolumeReq.volumeHeight && !newSkuWhExtAttrVo.productSkuVolumeReq.volumeLen && !newSkuWhExtAttrVo.productSkuVolumeReq.volumeWidth){
                            newSkuWhExtAttrVo.productSkuVolumeReq = null
                        }
                    }
                    // 敏感属性与体积:类目维度配置列表
                    let newCategorySkuWhExtAttrList = categorySkuWhExtAttrList
                    if(categorySkuWhExtAttrList && categorySkuWhExtAttrList.length){
                        newCategorySkuWhExtAttrList = categorySkuWhExtAttrList.map(i => ({
                            ...i,
                            categoryIds:i.categoryIds.join(',')
                        }))
                    }
                    // 包装信息
                    let newProductOuterPackageInfoVo = productOuterPackageInfoVo
                    if(newProductOuterPackageInfoVo){
                        newProductOuterPackageInfoVo.productOuterPackageImages = newProductOuterPackageInfoVo.productOuterPackageImages.map(url => ({imageUrl:url}))
                    }
                    let newValue = {
                        ...reset,
                        platform:PLATFORMID,
                        productWhExtAttrVo:newProductWhExtAttrVo,
                        customizedTechnologyVo:_customizedTechnologyVo,
                        categorySkuWhExtAttrList:newCategorySkuWhExtAttrList,
                        productOuterPackageInfoVo:newProductOuterPackageInfoVo,
                        skuWhExtAttrVo:newSkuWhExtAttrVo,
                        ...priceConf
                    }
                    const res = await saveCrossborderConfig(cloneDeep(newValue));
                    if (res) {
                        this.getConf();
                        this.$message.success('保存成功');
                    }
                }
            })
        },
        productOriginPreview(file) {
            window.open(this.productOriginImg, '_blank');
        },
        productOriginFileChange(v,fileList){
            const file = v.raw;
            const companyId = this.$store.getters.userInfo.companyId;
            this.productOriginFileList = fileList
            OSSClient.getInstance().singleUpload(`scm/${companyId}/${Date.now()}/${file.name}`, file, {
                success: res => {
                let f = {
                    fileName:file.name,
                    fileUrl:res.url
                }
                this.value.productWhExtAttrVo.productOriginCertFiles = [f]
                this.productOriginImg = res.url;
                },
                fail: res => {
                this.$message.error('上传失败,请重新上传');
                },
            });
        },
        productOriginFileRemove(file, fileList) {
            this.productOriginImg = '';
            this.value.productWhExtAttrVo.productOriginCertFiles[0].fileUrl = ''
        },
        technologyTypeChange(v) {
            this.technologyFirstTypeChange();
            this.value.customizedTechnologyVo.firstType = '';
        },
        technologyFirstTypeChange(v) {
            this.value.customizedTechnologyVo.twiceType = ''
            this.value.customizedTechnologyVo.multipleTwiceType = [];
        },
        getWidthAndHeights(refName) {
            return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : [];
        },
        regionChange(v){
            this.value.productWhExtAttrVo.productOrigin.region2Id = ''
            if(v === 'CN'){// 重置证明文件
                let obj = getDefaultProductWhExtAttr()
                this.value.productWhExtAttrVo.productOriginCertFiles = obj.productOriginCertFiles
                this.productOriginImg = ''
                this.productOriginFileList = []
            }
        },
    }
}
</script>

<style lang="scss" scoped>
  .content-wrp{
    ::v-deep .el-upload--text{
        display: block;
    }
    ::v-deep .el-upload-list__item{
        margin-top: 0px;
    }
  }
  .tips{
    font-size: 12px;
    color: #909399;
  }
</style>